import { render } from "./reservationsView.vue?vue&type=template&id=0beda2ad&scoped=true"
import script from "./reservationsView.vue?vue&type=script&lang=js"
export * from "./reservationsView.vue?vue&type=script&lang=js"

import "./reservationsView.vue?vue&type=style&index=0&id=0beda2ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0beda2ad"]])

export default __exports__